var r = function (a) {
  return a.default = "default", a.large = "large", a;
}(r || {});
export { r as InputPickerSize };